import React from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import moment from 'moment';

import { SECOND_REVIEW_DETAILS_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { Filter, Main } from 'Containers';
import * as ReportSelectors from 'State/report/selectors';
import * as ReportActions from 'State/report/actions';
import { GenerateReport } from 'Common/ObjectHelper';
import { errorToast } from 'Common/ToastHelper';
import * as ControlInfoActions from 'State/controlInfo/actions';
import * as CommonSelectors from 'State/selectors';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { SecondReviewDetailsEnum as Fields } from 'Common/FieldEnum';

import { SecondReviewDetailsForm } from './components/SecondReviewDetailsForm';

class SecondReviewDetails extends React.Component {
  path = '/secondreviewdetails';

  /** Fiscal year 2020 is school year 2019-2020, so the the from date should start july 1, 2019 */
  createInitialValues = (fiscalYear = moment().year() + 1) => ({
    [Fields.AllDates]: false,
    [Fields.OnlyShowModified]: false,
    [Fields.FromDate]: moment()
      .year(fiscalYear - 1)
      .month(6)
      .date(1)
      .format(DATE_FORMAT_FOR_UI),
    [Fields.ToDate]: moment()
      .year(fiscalYear - 1)
      .month(9)
      .date(31)
      .format(DATE_FORMAT_FOR_UI),
    [Fields.OrderBy]: 'FamilyNumber',
  });

  initialValues = this.createInitialValues();

  get mainProps() {
    const { fetching } = this.props;
    return {
      toolbox: {
        shown: true,
        saveButtonProps: {
          disabled: fetching,
          content: 'View Report',
          loading: fetching,
        },
        formName: SECOND_REVIEW_DETAILS_FORM_NAME,
      },
    };
  }

  componentDidMount() {
    const { getControlInfo } = this.props;
    getControlInfo();
  }

  componentDidUpdate(prevProps) {
    const { clearReport, resetError, fiscalYear, initialize } = this.props;

    errorToast(this.props, prevProps, 'reportError', resetError);

    GenerateReport(
      this.props,
      prevProps,
      'Recipe Preparation Report',
      'report',
      clearReport
    );

    if (prevProps.fiscalYear !== fiscalYear) {
      const initialValues = this.createInitialValues(fiscalYear);
      initialize(SECOND_REVIEW_DETAILS_FORM_NAME, initialValues);
    }
  }

  onSubmit = values => {
    const { getReport } = this.props;
    getReport('Reports/SecondReviewDetailReport', values);
  };

  render() {
    const { loading } = this.props;
    return (
      <React.Fragment>
        <Filter title={'Second Review Details'} />
        <Main {...this.mainProps}>
          <TitledCard title={'Options'}>
            <SecondReviewDetailsForm
              initialValues={this.initialValues}
              onSubmit={this.onSubmit}
              loading={loading}
            />
          </TitledCard>
        </Main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  report: ReportSelectors.getReportData(state),
  reportError: ReportSelectors.getReportError(state),
  fetching: ReportSelectors.getReportFetching(state),
  fiscalYear: CommonSelectors.fiscalYear(state),
  loading: CommonSelectors.getFetching(state),
});

const mapDispatchToProps = {
  clearReport: ReportActions.clearReport,
  resetError: ReportActions.resetError,
  getReport: ReportActions.getReport,
  getControlInfo: ControlInfoActions.getControlInfo,
  initialize,
};

SecondReviewDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondReviewDetails);

export { SecondReviewDetails };



// WEBPACK FOOTER //
// ./src/pages/secondreviewdetails/SecondReviewDetails.js